export const shouldRenderSectionsDirectly = ({ educationTemplateStyle, sections = [] } = {}) => (
  educationTemplateStyle === 'exam'
  && Array.isArray(sections)
  && sections.some((section) => section?.visible !== false && section?.type === 'educationExamShell')
);
